<div class="row first-steps">
  <div class="col-12 col-lg-6 to-do pb-md-5">
    <h4 class="text-black mb-4">GETTING STARTED</h4>
    <div [innerHTML]="gettingStartedContent"></div>
  </div>
  <div class="col-12 col-lg-6 pt-0 pb-0 pt-md-4 pb-md-5 pl-xl-5 pl-4 pr-4">
    <div class="include fundraising pr-xs-0 pb-0">

      <ngb-carousel #tips>
        <ng-template ngbSlide *ngFor="let tip of fundraisingTips">
          <h4 class="text-primary">FUNDRAISING IDEAS</h4>
          <p>
            {{tip.content}}
          </p>
          <button type="button" (click)="prev()" class="btn btn-primary btn-sm mt-3 mr-2">Previous</button>
          <button type="button" (click)="next()" class="btn btn-primary btn-sm mt-3">Next</button>
        </ng-template>
      </ngb-carousel>
    </div>
  </div>
</div>
